import { render, staticRenderFns } from "./ChartPosicion.vue?vue&type=template&id=af1c4d16&"
import script from "./ChartPosicion.vue?vue&type=script&lang=js&"
export * from "./ChartPosicion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports